import Background1 from "../assets/berries.jpg"; // Import your background image

const slidesData = [
  {
    title: "Confessions of a Nutrition Freak",
    description: "Welcome to Confessions of a Nutrition Freak.",
    backgroundImage: Background1,
  },
  {
    title: "Confessions of a Nutrition Freak",
    description: "Are you tired of fad diets that don't work?",
    backgroundImage: Background1,
  },
  {
    title: "Confessions of a Nutrition Freak",
    description: "Curious about how simple changes in your daily meals can transform your energy and vitality?",
    backgroundImage: Background1,
  },
  {
    title: "Confessions of a Nutrition Freak",
    description: "You've come to the right place!",
    backgroundImage: Background1,
  },
  {
    title: "Confessions of a Nutrition Freak",
    description: "At Confessions of a Nutrition Freak, we believe that food is more than just fuel. It's a way of life.",
    backgroundImage: Background1,
  },
  {
    title: "Confessions of a Nutrition Freak",
    description: "Let's embark on this journey together! Are you ready?",
    backgroundImage: Background1,
  },
];


export default slidesData;
